exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addNewCardPage-pageContent{display:flex;flex-direction:column;align-items:center;background-color:'transparent';padding:3vh 1vh}.addNewCardPage--colorinputSection{width:40%;padding:2%;background-color:var(--box-background);box-shadow:0 1px 2px 0 var(--box-shadow-color);border-radius:5px}@media screen and (max-width: 960px){.addNewCardPage--colorinputSection{width:'80%'}}\n", ""]);

// exports
